/******************************************************************************
 * Created Date: Thursday June 25th 2020                                      *
 * Author: Sean W.                                                            *
 * -----                                                                      *
 * Last Modified: Fri Oct 15 2021                                             *
 * Modified By: Sean W.                                                       *
 * -----                                                                      *
 * File: /src/reducers/iotMessagesReducer.js                                  *
 * Copyright (c) 2020 MultiSensor                                             *
 ******************************************************************************/

import * as types from "../actions/actionTypes";

import initialState from "./initialState";

const MAX_ROWS = 1000;

const iotMessagesReducer = (state = initialState.iotMessages, action) => {
  if (action.type === types.NEW_IOT_MESSAGE) {
    let resultArray = [...state, { ...action.message }];
    if (resultArray.length > MAX_ROWS) resultArray.shift();
    return resultArray;
  } else if (action.type === types.CLEAR_IOT_MESSAGES) {
    return [];
  }
  return state;
};

export default iotMessagesReducer;
